export const sharedStylesFromSelDesign = () => ({
  '.advanced-settings-section .form-group .col-sm-10 .camp-adg-shared-text-under-dropdown': {
    marginBottom: '0px',
    marginTop: '6px',
  },
  '.audience-advanced-settings .form-group .col-sm-10 .camp-adg-shared-text-under-dropdown': {
    marginBottom: '0px',
    marginTop: '6px',
  },
  '.camp-adg-shared-label-spacing': {
    marginTop: '12px',
  },
  '.camp-adg-shared-label': {
    fontWeight: '600',
  },
  '.row .camp-adg-shared-instruction-spacing': {
    marginBottom: '10px',
  },
  '.row .camp-adg-shared-first-textarea-spacing': {
    marginTop: '8px',
  },
  '.row .camp-adg-shared-spacing-between-textareas': {
    marginTop: '35px',
  },
  // Space between text areas for campaign settings exclusions section
  '.advanced-settings-section .form-group .ip-exclusion': {
    marginTop: '34px',
  },
  '.camp-adg-shared-disabled-textarea': {
    backgroundColor: '#ffffff',
  },
  '.camp-adg-shared-textarea': {
    borderWidth: '2px',
  },
  '.camp-adg-shared-exclusions-dropdown': {
    marginLeft: '15px',
  },
  'a.camp-adg-shared-exclusions-dropdown:hover, a.trackingTemplateSection:hover, a.finalUrlSuffixSection:hover, a.customParametersSection:hover': {
    textDecoration: 'none',
    paddingBottom: '2px',
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
  },
});
